import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import * as g from 'src/app/globals';
import { CashUsrInfo, PayPalUsrInfo, PayUsrCard } from './documents';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  constructor(private http: HttpClient) { }
  lang = g.language;
  baseUrl = `${g.baseUrl}Tokeniz/`;
  urlSuffix = '&app=ITM-TOKENIZ&language=' + this.lang;
  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Credentials': 'true',
    }),
  };

  createDocuments(url, data) {
    return this.http.get(
      `${this.baseUrl
      }${url}?token=${data.limitToken}&online=${data.online}`
    );
  }

  // POST
  getPaypalLink(url, data): Observable<PayPalUsrInfo> {
    return this.http
      .post<PayPalUsrInfo>(
        this.baseUrl + url,
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.errorHandler));
  }

  // POST
  sendPayInfo(data): Observable<PayUsrCard> {
    return this.http
      .post<PayUsrCard>(
        this.baseUrl + 'AuthorizeNetCheckOut/Checkout',
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.errorHandler));
  }

  // POST
  sendCashPayinfo(url, data): Observable<CashUsrInfo> {
    return this.http
      .post<CashUsrInfo>(
        this.baseUrl + url + data,
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.errorHandler));
  }

  // GET
  getDocumentsInfo(data) {
    return this.http
      .get(`
        ${this.baseUrl}Tokeniz/GetModuleInfo?token=${g.getToken()}`
      )
      .pipe(retry(1), catchError(this.errorHandler));
  }

  activitiesList(docType, selectedId) {
    return this.http.get(
      `${this.baseUrl
      }Tokeniz/ActivityList?docType=${docType}&selectedId=${selectedId}`
    ).pipe(retry(1), catchError(this.errorHandler));

  }
  // GET
  setDocumentsAction(data, actionType: string) {
    const url = actionType === 'approve' ? 'TokenizedDocument/QuotationApprove'
      : actionType === 'reject' ? 'TokenizedDocument/QuotationReject'
        : 'TokenizedDocument/QuotationComment';
    return this.http
      .get(
        `${this.baseUrl}${url}?notes=${data.notes}&emailSubject=${data.emailSubject}&emailBody=${data.emailBody}`
      )
      .pipe(retry(1), catchError(this.errorHandler));
  }

  getPOStatusList(data) {
    return this.http.get(
      `${this.baseUrl
      }Tokeniz/GetPOStatusList?online=${data.online}&language=${this.lang}&app=ITM-TOKENIZ`
    );
  }

  // Error handling
  errorHandler(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  checkQuotation(docEntry) {
    return this.http.get(`${this.baseUrl}Tokeniz/IsQuotationClosed?token=${g.getToken()}&docEntry=${docEntry}`);
  }
}
